import { DatePicker, Radio, Select } from "antd";
import { Col, Form, Input, Row } from "antd";
import React, { FC } from "react";

type DischargeDetailsProps = {
  form: any;
  portalSubmission: any;
  isApproved: any;
};

const DischargeDetails: FC<DischargeDetailsProps> = ({ form, portalSubmission, isApproved }) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";

  const isRoutineDischarge = Form.useWatch("typeOfDischarge", form);
  const isAssuredBy = Form.useWatch('routineDischarge', form);
  const isHospitalStaff = Form.useWatch('assuredBy', form);

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Discharge Details
      </div>
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            {/* <Form.Item
              label="Type Of Discharge"
              name="typeOfDischarge"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select type of discharge",
                },
              ]}
            >
              <Radio.Group
                options={[
                  {
                    label: "Against Medical Advice",
                    value: "Against Medical Advice",
                  },
                  {
                    label: "Death",
                    value: "Death",
                  },
                  {
                    label: "Routine Discharge",
                    value: "Routine Discharge",
                  },
                ]}
              />
            </Form.Item> */}

            <Form.Item
              label="Type Of Discharge"
              name="typeOfDischarge"
              rules={[
                {
                  required: true,
                  message: "Please select type of discharge",
                },
              ]}
            >
              <Select
                placeholder="Select type of discharge"
                style={{ maxWidth: 300 }}
                disabled={portalSubmission}
              >
                {[
                  {
                    label: "Against Medical Advice",
                    value: "Against Medical Advice",
                  },
                  {
                    label: "Death",
                    value: "Death",
                  },
                  {
                    label: "Routine Discharge",
                    value: "Routine Discharge",
                  },
                ]?.map((option) => (
                  <Select.Option key={option?.value} value={option?.value}>
                    {option?.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {isRoutineDischarge === "Routine Discharge" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              {/* <Form.Item
              label="Routine Discharge"
              name="routineDischarge"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select Routine Discharge",
                },
              ]}
            >
              <Radio.Group
                options={[
                  {
                    label: "Formality is completed & patient is leaving",
                    value: "Formality is completed & patient is leaving",
                  },
                  {
                    label: "Patient paying Caution Deposit/Bill & leaving",
                    value: "Patient paying Caution Deposit/Bill & leaving",
                  },
                  {
                    label: "Patient leaving on Assurance",
                    value: "Patient leaving on Assurance",
                  },
                ]}
              />
            </Form.Item> */}
              <Form.Item
                label="Routine Discharge"
                name="routineDischarge"
                rules={[
                  {
                    required: true,
                    message: "Please select Routine Discharge",
                  },
                ]}
              >
                <Select
                  placeholder="Select Routine Discharge"
                  style={{ maxWidth: 300 }}
                  disabled={portalSubmission}
                >
                  {[
                    {
                      label: "Formality is completed & patient is leaving",
                      value: "Formality is completed & patient is leaving",
                    },
                    {
                      label: "Patient paying Caution Deposit/Bill & leaving",
                      value: "Patient paying Caution Deposit/Bill & leaving",
                    },
                    {
                      label: "Patient leaving on Assurance",
                      value: "Patient leaving on Assurance",
                    },
                  ]?.map((option) => (
                    <Select.Option key={option?.value} value={option?.value}>
                      {option?.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}

          {
            isAssuredBy === "Patient leaving on Assurance" ? <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            {/* <Form.Item
              label="Assured By"
              name="assuredBy"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select Assured By",
                },
              ]}
            >
              <Radio.Group
                options={[
                  {
                    label: "Hospital Staff",
                    value: "Hospital Staff",
                  },
                  {
                    label: "Other",
                    value: "Other",
                  },
                ]}
              />
            </Form.Item> */}

            <Form.Item
              label="Assured By"
              name="assuredBy"
              rules={[
                {
                  required: true,
                  message: "Please select Assured By",
                },
              ]}
            >
              <Select placeholder="Select Assured By" style={{ maxWidth: 300 }} disabled={portalSubmission}>
                {[
                  {
                    label: "Hospital Staff",
                    value: "Hospital Staff",
                  },
                  {
                    label: "Other",
                    value: "Other",
                  },
                ]?.map((option) => (
                  <Select.Option key={option?.value} value={option?.value}>
                    {option?.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col> : <></>
          }

          
          {
            isHospitalStaff === "Hospital Staff" ? <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Name"
              name="nameOfAssurer"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input name",
                },
              ]}
            >
              <Input
                placeholder="Please input Name"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col> : <></>
          }
          
          {
             isHospitalStaff === "Hospital Staff" ? <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Designation"
              name="designationOfAssurer"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input designation",
                },
              ]}
            >
              <Input
                placeholder="Please input designation Of Assurer"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col> : <></>
          }
          
          {
            isHospitalStaff === "Hospital Staff" ? <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Relation To the Patient"
              name="relationOfPatientToAssurer"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input relation to the patient",
                },
              ]}
            >
              <Input
                placeholder="Please input Relation To the Patient"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col> : <></>
          }
          

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Date of discharge"
              name="dateOfDischarge"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input dod",
                },
              ]}
            >
              <DatePicker
                placeholder="Please input dod"
                style={{ color: "black", width: "100%" }}
                format={dateFormat}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Remarks"
              name="remarks"
              style={{ color: "#575757" }}
              // rules={[
              //   {
              //     pattern: /^\d+$/,
              //     message: "Only Numeric values are allowed!",
              //   },
              // ]}
            >
              <Input
                placeholder="Please input remarks"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default DischargeDetails;
